// extracted by mini-css-extract-plugin
export default {"login_btn":"Login_login_btn__QtfuS","login_card":"Login_login_card__Kw8kH"};